export var closeAccountReasonMapping = {
    DETAILS_REUSE: 'need to use my information in another account',
    NO_LONGER_REQUIRED: 'dont want a home depot account anymore',
    DUPLICATE_ACCOUNT: 'have more than one home depot account',
    FRAUD_ACTIVITY: 'fraudulent activity or security incident on my account',
    OTHER: 'other',
};
// eslint-disable-next-line no-shadow
export var CloseAccountReasonChoice;
(function (CloseAccountReasonChoice) {
    CloseAccountReasonChoice["DETAILS_REUSE"] = "DETAILS_REUSE";
    CloseAccountReasonChoice["NO_LONGER_REQUIRED"] = "NO_LONGER_REQUIRED";
    CloseAccountReasonChoice["DUPLICATE_ACCOUNT"] = "DUPLICATE_ACCOUNT";
    CloseAccountReasonChoice["FRAUD_ACTIVITY"] = "FRAUD_ACTIVITY";
    CloseAccountReasonChoice["OTHER"] = "OTHER";
})(CloseAccountReasonChoice || (CloseAccountReasonChoice = {}));
